import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const ChevronLeftIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M16.0795 7.48046L11.0555 11.9835L15.9193 16.6591L14.3727 18.0423L8.00063 11.9301L14.5821 6.04411L16.0795 7.48046Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
ChevronLeftIcon.displayName = 'ChevronLeftIcon'
export default ChevronLeftIcon
